<template>
  <el-container style="position: relative; box-sizing: border-box">
    <!-- 系统页面 -->
    <div style="width: 100vw" v-if="!$store.state.isHome">
      <el-header :height="headerHeight">
        <systemHeader></systemHeader>
      </el-header>
      <tags-view></tags-view>
      <div :style="{ height: 'calc(100vh - 100px)' }">
        <router-view></router-view>
      </div>
    </div>
    <!-- 首页 -->
    <div style="width: 100vw" v-else>
      <router-view></router-view>
    </div>
	<!-- 会议邀请 -->
    <div class="alert-info" v-if="meetShow">
      <div class="alert-top">
        <div class="left">
          <p>会议邀请({{alarmInformation2.title}})</p>
          <span>{{ alarmInformation2.content }}</span>
          <span>收到新的会议邀请，请及时处理！</span>
        </div>
        <div class="right">
          <i class="iconfont iconhuiyi"></i>
        </div>
      </div>
      <div class="alert-btn-box">
        <div class="cancel" @click="meetShow = !meetShow">稍后查看</div>
        <div class="confirm" @click="acceptAlarm2()">参加会议</div>
      </div>
    </div>
    <!-- 一键报警 -->
    <div class="alert-info" v-if="showWarn">
      <div class="alert-top">
        <div class="left">
          <p>{{ anarmType(alarmInformation.title) }}</p>
          <span>你有一条新的警报消息!</span>
        </div>
        <div class="right">
          <i class="iconfont iconyingjijingbao iMG"></i>
        </div>
      </div>
      <div class="alert-btn-box">
        <div class="cancel" @click="(showWarn = !showWarn), closeAudio()">暂不处理</div>
        <div class="confirm" @click="acceptAlarm(), closeAudio()">接受</div>
      </div>
    </div>
    <audio ref="audio" src="../../assets/audio/alarm.mp3" hidden preload="auto"></audio>
    <!-- 联动视频聊天 -->
    <div class="alarm-message" v-if="alarmBoxShow">
      <img :src="visionImg" alt="" />
      <h6>{{ visionName }}</h6>
      <span>邀请你进行视频通话...</span>
      <div>
        <span class="vision-btn" @click="(alarmBoxShow = false), clearInterval(tiemr)">
          <i class="iconfont iconguaduan"></i>
        </span>
        <span class="vision-btn" @click="videoBox(groupId), (alarmBoxShow = false)">
          <i class="iconfont icontelephone"></i>
        </span>
      </div>
    </div>
    <!-- 会议视频聊天 -->
    <div class="alarm-message" v-if="alarmBoxShow1">
      <img :src="visionImg" alt="" />
      <h6>{{ visionName }}</h6>
      <span>邀请你进行视频通话...</span>
      <div>
        <span class="vision-btn" @click="alarmBoxShow1 = false">
          <i class="iconfont iconguaduan"></i>
        </span>
        <span class="vision-btn" @click="videoBox1(meetingId)">
          <i class="iconfont icontelephone"></i>
        </span>
      </div>
    </div>
  </el-container>
</template>

<script>
import { createWebSocket } from "../../assets/js/socket";
// import server from "../../../public/server/server";
import publicFn from "../../assets/js/publicFn";
import systemHeader from "../../components/system-header/system-header";
import tagsView from "../../components/tagsView";
import { mapAPI } from "../../api-path/command-center";
import { loginApi } from "../../api-path/login-api.js";
import publicAPI from "../../api-path/public-api";
import { listAPI } from "@/api-path/command-center.js";

const href = window.location.href.split("#")[1];
export default {
  name: "system-index",
  inject: ["reload"],
  components: {
    systemHeader,
    tagsView
  },
  data() {
    return {
      meetShow: false,
      alarmBoxShow: false,
      showWarn: false,
      groupId: "",
      notCompare: {}, //发出的所有消息出的消息
      headerHeight: "60px",
      containerHight: "",
      transmittedList: [],
      alarmInformation: {}, //报警信息
      alarmInformation2: {}, //会议
      tiemr: undefined,
      second: 30,

      timeInterVal: "", //im定时器
      visionImg: "", //视频会话头像
      // alarmImg:"",//报警头像

      //会议
      // showMeeting:false,
      meetingInfo: {},
      alarmBoxShow1: false,
      meetingId: "",
    };
  },
  computed: {
    breadcrumbData: function () {
      return this.$store.state.breadcrumbData;
    },
  },
  beforeRouteLeave(to, from, next) {
    this.senSocket(4, 1);
    next();
  },
  created() {
    this.containerHight = `calc(100vh - ${this.headerHeight})`;
    this.$store.commit("setIsBreakIM", false);
    createWebSocket(this.initEventHandle);
  },
  beforeDestroy() {
    clearInterval(window.timeInterVal);
  },
  methods: {
    //警报声音
    palyAudio() {
      let that = this;
      that.$refs.audio.play();
      that.tiemr = setTimeout(() => {
        that.$refs.audio.pause();
      }, 35000);
    },
    closeAudio() {
      clearInterval(this.tiemr);
      if (this.$refs.audio) {
        this.$refs.audio.pause();
      }
    },
    anarmType(titleType) {
      let titleName = "";
      let codeData = JSON.parse(localStorage.getItem("codeData"));
      codeData["ALARM_TYPE"]
        ? codeData["ALARM_TYPE"].forEach((r) => {
            if (r.itemValue == titleType) {
              titleName = r.itemName;
            }
          })
        : null;
      return titleName;
    },
    anarmType2(titleType) {
      let titleName = "";
      let codeData = JSON.parse(localStorage.getItem("codeData"));
      codeData["ALARM_TYPE"].forEach((r) => {
        if (r.itemValue == titleType) {
          titleName = r.itemName;
        }
      });
      return titleName;
    },
    decidePage() {
      let path = this.$route.path;
      return path == "/command/map" ? true : false;
    },
    acceptAlarm() {
      //接受警报
      this.showWarn = false;
      this.closeAudio();
      this.$http
        .post(`${mapAPI.addClues}`, {
          alarmId: this.alarmInformation.msgid,
          fileDTOList: [],
          handleType: 4,
        })
        .then((res) => {
          if (res.status === 200) {
            this.goDetail(this.alarmInformation.msgid); //跳转联动报警
          }
        });
    },
    //跳转联动报警
    goDetail(id) {
      this.$http.get(listAPI.datail + "?alarmId=" + id).then((res) => {
        if (res.status == 200) {
          localStorage.setItem("eventUserId", res.result.userId);
          sessionStorage.setItem("groupId", id);
          this.$store.commit("setVisionGroupId", id);
          sessionStorage.setItem("alarmInfo", JSON.stringify(res.result));
          this.$store.commit("setAlarmId", id);
          this.closeAudio();
          sessionStorage.setItem("active", "/command");
          let href = window.location.href.split("#")[1];
          if (res.result.report) {
            //是否已上报
            if (href != "/command/up-report") {
              this.$store.commit("setVisionGroupId", id);
              sessionStorage.setItem("active", "/command");
              this.$router.push({ path: "/command/up-report" });
            } else {
              this.$store.commit("setVisionGroupId", id);
            }
          } else if (res.result.join) {
            //已参与
            if (href != "/command/participation") {
              this.$store.commit("setVisionGroupId", id);
              sessionStorage.setItem("active", "/command");
              this.$router.push({ path: "/command/participation" });
            } else {
              this.$store.commit("setVisionGroupId", id);
            }
          } else if (res.result.status == 2) {
            //处理中
            if (href != "/command/map") {
              if (href != "/home") {
                sessionStorage.setItem("active", "/command");
                this.$router.push({
                  path: "/command/map",
                });
              } else {
                // sessionStorage.setItem('active','/command')
                this.$router.replace("/command/map");
              }
            }
          } else if (res.result.status == 6) {
            //分派任务
            if (href != "/command/map") {
              sessionStorage.setItem("active", "/command");
              this.$router.push({
                path: "/command/map",
              });
            }
          }
        } else {
          $this.$store.commit("setHasNewAlarm", true);
        }
      });
    },
    //获取报警群成员
    getData(groupId, senderId) {
      const $this = this;
      this.$http.get(mapAPI.getGroupUserInfo + "?groupId=" + groupId).then((res) => {
        if (res.status === 200) {
          let notGroupMember = JSON.parse(
            JSON.stringify($this.$store.state.notGroupMember)
          );
          notGroupMember[this.groupId] = res.result;
          this.$store.commit("setGroupMember", notGroupMember);
          res.result.map((item) => {
            if (item.id == senderId) {
              $this.visionImg = item.portrait;
              $this.visionName = item.realName;
            }
          });
          $this.alarmBoxShow = true;
        }
      });
    },
    //获取会议成员
    getMeetingData(groupId, senderId) {
      this.meetingId = groupId;
      this.$http
        .get(publicAPI.groupUserInfo, { params: { groupId: groupId } })
        .then((res) => {
          if (res.status == 200) {
            res.result.map((item) => {
              if (item.id == senderId) {
                this.visionImg = item.portrait;
                this.visionName = item.realName;
              }
            });
            this.alarmBoxShow1 = true;
          }
        });
    },
    videoBox(id) {
      //视频会议
      this.$http.get(`${publicAPI.getAlarmStream}?alarmId=${id}`).then((res) => {
        if (res.status === 200) {
          if (window.QCefClient) {
            res.result.type = 3;
            res.result.userId = sessionStorage.getItem("userId");
            window.QCefClient.invokeMethod(
              "QCef_Open_Player",
              3,
              false,
              JSON.stringify(res.result)
            );
          }
          this.goDetail(id);
        }
      });
    },
    videoBox1(id) {
      //会议视频联动
      this.$http
        .get(`${publicAPI.getAlarmStream}?alarmId=${this.meetingId}`)
        .then((res) => {
          if (res.status === 200) {
            if (window.QCefClient) {
              res.result.type = 3;
              res.result.userId = sessionStorage.getItem("userId");
              window.QCefClient.invokeMethod(
                "QCef_Open_Player",
                3,
                false,
                JSON.stringify(res.result)
              );
            }
          }
        });
      this.acceptAlarm2();
    },
    //跳转会议
    acceptAlarm2() {
      this.$http
        .get(publicAPI.getGroupInfo, { params: { groupId: this.meetingId } })
        .then((res) => {
          if (res.status == 200) {
            if (res.result.deleted) {
              //结束
              this.$notify({
                title: "会议提示",
                message: "《" + res.result.groupName + "》" + "会议已结束！",
              });
              this.alarmBoxShow1 = false;
              this.meetShow = false;
            } else {
              this.alarmBoxShow1 = false;
              this.meetShow = false;
              let href = window.location.href.split("#")[1];
              if (href == "/visual-intercom/real-time-intercom") {
                sessionStorage.setItem("active", "/visual-intercom");
                this.$store.commit("setMeetingId", this.meetingId);
                sessionStorage.setItem("meetingId", this.meetingId);
              } else {
                sessionStorage.setItem("active", "/visual-intercom");
                this.$store.commit("setMeetingId", this.meetingId);
                sessionStorage.setItem("meetingId", this.meetingId);
                this.$router.push({ path: "/visual-intercom/real-time-intercom" });
              }
            }
          }
        });
    },
    senSocket(cmd, msgtype) {
      //请求接口命令字1绑定2心跳,3上线,4下线,5消息,6重连,7群通知,8客户端收到消息确认,9消息已读确认
      let data = {
        cmd: cmd,
      };
      if (msgtype) {
        data.msgtype = msgtype;
      }
      let userId = sessionStorage.getItem("userId");
      publicFn.sendMsg(data, userId);
    },
    initEventHandle() {
      let $this = this;
      //打开IM
      window.websock.onopen = function () {
        $this.$store.commit("setIsIm", true);
        $this.senSocket(1, 1);
        // console.log("上线了");
        window.timeInterVal = setInterval(() => {
          $this.senSocket(2, 1);
          // console.log("发心跳了");
        }, 10000);
      };
      //收到信息
      window.websock.onmessage = function (event) {
        if (event.data instanceof ArrayBuffer) {
          let msg = new proto.Model.deserializeBinary(event.data);
          let getCmd = msg.getCmd();
          let getMsgtype = msg.getMsgtype();
          let msgCon = new proto.MessageBody.deserializeBinary(msg.getContent())
          let getType=msgCon.getGrouptype();
          let type=msgCon.getType();
          // im类型（1请求2应答3通知4响应）：getMsgtype
          //消息类型（1绑定2心跳3上线4下线5消息6重连7群通知8客户端收到消息确认9消息已读确认10服务端报警信息推送11预约会议消息推送）：getCmd
          //消息内容类型：getType
          //消息内容：msgCon
          // console.log(`${getMsgtype}/${getCmd}/${getType}`);
          // console.log(msgCon);
          //请求
          if (getMsgtype == 1) {
            if (getCmd == 5) {
              if (msg.getSender() != sessionStorage.getItem("userId")) {
                let data = {
                  cmd: 8,
                  msgId: msg.getMsgid(),
                  msgtype: 3,
                };
                publicFn.sendMsg(data);
                if (msg.getGroupid()) {
                  let Content = {
                    sendUserId: msg.getSender(),
                    timeStamp: msg.getTimestamp() * 1000,
                    content: msgCon.getContent(),
                    isMe: 0,
                    type: getType,
                  };
                  $this.senSocket(8, 3);
                  $this.listPush(Content, msg.getGroupid());
                }
                if (type === 9) {
                  $this.groupId = msg.getGroupid();
                  $this.getData($this.groupId, msg.getSender());
                  return;
                }
                if (type === 30) {
                  $this.getMeetingData(msg.getGroupid(), msg.getSender());
                  return;
                }
                if (type === 31) {
                  $this.meetingId = msg.getGroupid();
                  $this.videoBox1();
                  return;
                }
              } else {
                let data = {
                  cmd: 8,
                  msgId: msg.setMsgid(),
                  msgtype: 3,
                };
                publicFn.sendMsg(data);
              }
            }
          }
          //应答
          if (getMsgtype == 2) {
            let notCompare = $this.$store.state.notCompare;
            let groupId = msg.getGroupid();
            let groupIdInfo = notCompare[groupId];
            if (getCmd == 1) {
              // console.log("IM上线成功了");
            }
            if (getCmd == 2) {
              // console.log("心跳成功收到,请继续保持");
            }
            if (getCmd == 5) {
              if (groupIdInfo!=undefined&&groupIdInfo.length > 0) {
                groupIdInfo.forEach((item) => {
                  if (item.isMe == 1 &&msg.getCheckid() &&item.checkid === msg.getCheckid()) {
                    item.loading = false;
                  }
                });
                // console.log(notCompare, "信息得到了回执");
                $this.$store.commit("changeData", notCompare);
              }
            }
          }
          //通知
          if (getMsgtype == 3) {
            if (getCmd == 7) {
              let msgInfo = {
                groupId: msg.getGroupid(),
                groupType: msgCon.getGrouptype(),// 1解散2加入3移除4已读
                msgtype: getMsgtype,
                cmd: getCmd,
                groupName: msgCon.getTitle(),
                content:msgCon.getContent(),
                portrait:msgCon.getPortrait(),
              };
              if (getType === 1) {
                if (href != "/visual-intercom/real-time-intercom") {
                  // console.log('sdfffffffffffffff')
                  $this.$store.commit("setMeetingId", "");
                  sessionStorage.setItem("meetingId", "");
                  $this.$store.commit("setCurrentMeetingInfo", {});
                  $this.$notify({
                    title: "会议提示",
                    message: "你有进行中的会议已结束！",
                  });
                }
              }else{
                $this.$store.commit("setCurrentMeetingInfo", msgInfo);
              }
              $this.listPush({
                timeStamp:Number(msgCon.getTime()),
                content:msgCon.getContent(),
                type:99
              }, msg.getGroupid());
              
            }
            if (getCmd == 4) {
              $this.$http.get(loginApi.logOut).then((res) => {
                if (res.status === 200) {
                  $this.$message.error("你的账号在其他地方登录,如果不是本人操作,请修改密码,保证帐号安全!");
                  $this.$store.commit("setIsBreakIM", true);
                  $this.$store.commit("setAlarmId", "");
                  $this.$store.commit("clearLoginInfo");
                  $this.$router.push("/login");
                }
              });
            }
            if (getCmd == 10) {
              $this.alarmInformation = {
                msgid: msg.getMsgid(), //报警id
                title: msgCon.getTitle(), //类型，
                extendse: msgCon.getExtend(), //
                longitude: msg.getLongitude(), //
                latitude: msg.getLatitude(), //
              };
              if (msgCon.getType() === 11 || msgCon.getType() === 4) {
                // 报警

                let href = window.location.href.split("#")[1];
                if (href == "/command/pending") {
                  $this.$store.commit("setHasNewAlarm", true);
                }
                $this.showWarn = false;
                $this.closeAudio();
                $this.showWarn = $this.alarmInformation.extendse === "1" ? true : false;
                if ($this.alarmInformation.extendse === "1") {
                  setTimeout(() => {
                    $this.palyAudio();
                  }, 3000);
                  $this.$store.commit("setAlarmCount", {
                    type: "add",
                    name: "pendingCount",
                  });
                }
              } else if (
                msgCon.getType() === 8 ||
                msgCon.getType() === 5 ||
                msgCon.getType() === 7
              ) {
                //取消报警
                if ($this.alarmInformation.msgid == $this.$store.state.alarmId) {
                  $this.$store.commit("setIsForbidden", true);
                }
                let href = window.location.href.split("#")[1];
                if (
                  $this.$store.state.alarmId == $this.alarmInformation.msgid &&
                  href == "/command/map"
                ) {
                  //应急联动页面
                  $this.$store.commit("setAlarmId", "");
                  $this.$alert("该报警已取消！", "提示", {
                    confirmButtonText: "确定",
                    callback: (action) => {
                      $this.$router.push({
                        path: "/command/pending",
                      });
                    },
                  });
                } else if (href == "/command/pending" || href == "/command/processing") {
                  //业务处理页面
                  $this.$notify({
                    title: "警情提示",
                    message: "你有一条处理中的报警该已取消！",
                  });
                  $this.$store.commit("setAlarmId", "");
                  $this.reload(); //刷新页面
                } else {
                  //其他页面
                  $this.$notify({
                    title: "警情提示",
                    message: "你有一条处理中的报警已取消！",
                  });

                  $this.$store.commit("setAlarmId", "");
                }
              }
              // this.alertType()
            }
            if (getCmd == 11) {
              //收到会议信息
              $this.alarmInformation2 = {
                groupId: msg.getGroupid(), //群号
                content: new Date(msgCon.getTime()).Format("yyyy-MM-dd hh:mm:ss"), //会议开始时间
                title: msgCon.getTitle(), //会议
                content:msgCon.getContent()
              };
              $this.meetingId = msg.getGroupid();
              $this.meetShow = true;
              if (href == "/visual-intercom/real-time-intercom") {
                sessionStorage.setItem("active", "/visual-intercom");
                $this.$store.commit("setMeetingId", $this.meetingId);
                sessionStorage.setItem("meetingId", $this.meetingId);
              }
            }
          }
        } else {
          let data = event.data; //后端返回的是文本帧时触发
          console.log(data);
        }
      };
      //连接关闭
      window.websock.onclose = function (event) {
        clearInterval(window.timeInterVal);
        $this.$message.error("IM链接断开了", event);
        $this.$store.commit("setIsIm", false);
        setTimeout(() => {
          createWebSocket($this.initEventHandle);
        }, 5000);
      };
      window.websock.onerror = function () {
        $this.$message.error("IM链接错误", event);
      };
    },
    listPush(data, groupId) {
      let $this = this;
      let notCompare = JSON.parse(JSON.stringify($this.$store.state.notCompare));

      if (notCompare[groupId] && notCompare[groupId].length > 0) {
        let newData = [...notCompare[groupId], ...[data]];
        notCompare[groupId] = newData;
      } else {
        notCompare[groupId] = [];
        notCompare[groupId] = [data];
      }
      $this.$store.commit("changeData", notCompare);
    },
    peonArr(list) {
      let obj = {};
      return list.reduce((cur, next) => {
        obj[next.checkid] ? "" : (obj[next.checkid] = true && cur.push(next));
        return cur;
      }, []); //设置cur默认类型为数组，并且初始值为空的数组
    },
  },
};
</script>

<style lang="less">
@import "system-index";
</style>
